import React from "react";
import { useNavigate, useLocation } from "react-router-dom";
import TagFullColoredIcon from "../../../../icons/tag-full-colored.icon";
import StatusFullColoredIcon from "../../../../icons/status-full-colored.icon";
import SubscriptionIcon from "../../../../icons/subscription.icon";
import NetworkAccessIcon from "../../../../icons/network-access.icon";
import EmailIcon from "../../../../icons/email.icon";
import styles from "./side-menu.module.scss";

export const DistributorSettingsSideMenu = ({ basePath, getRoutePath }) => {
  const navigate = useNavigate();
  const location = useLocation();
  const currentPath = location.pathname;

  const menuItems = [
    {
      id: "company-settings",
      label: "Company Settings",
      iconPath: "/images/settings-nav/company_settings.svg",
      route: getRoutePath("company-settings"),
    },
    {
      id: "tags",
      label: "Tags",
      icon: TagFullColoredIcon,
      route: getRoutePath("tags"),
    },
    {
      id: "statuses",
      label: "Statuses",
      icon: StatusFullColoredIcon,
      route: getRoutePath("statuses"),
    },
    {
      id: "subscriptions",
      label: "Subscriptions",
      icon: SubscriptionIcon,
      route: getRoutePath("subscriptions"),
    },
    {
      id: "network-access",
      label: "Network Access",
      icon: NetworkAccessIcon,
      route: getRoutePath("network-access"),
    },
    {
      id: "email-templates",
      label: "Email Templates",
      icon: SubscriptionIcon,
      route: getRoutePath("email-templates"),
    },
  ];

  const handleItemClick = (route) => {
    if (route) {
      navigate(route);
    }
  };

  return (
    <nav className={styles.nav} role="navigation" aria-label="Account settings navigation">
      {menuItems.map((item) => {
        const IconComponent = item.icon;
        const isActive = currentPath === item.route || (item.id === "company-settings" && currentPath === basePath);
        const iconColor = isActive ? "#616778" : "#9499AA";
        
        return (
          <div
            key={item.id}
            className={`${styles.menuItem} ${isActive ? styles.active : ""}`}
          >
            <button
              className={styles.menuButton}
              onClick={() => handleItemClick(item.route)}
              aria-current={isActive ? "page" : undefined}
            >
              <div className={styles.iconWrapper}>
                {item.iconPath ? (
                  <img 
                    src={item.iconPath} 
                    alt="" 
                    className={styles.icon}
                    style={{ 
                      filter: isActive ? 'none' : 'opacity(0.65)',
                      width: '16px',
                      height: '16px'
                    }}
                  />
                ) : (
                  <IconComponent className={styles.icon} fill={iconColor} />
                )}
              </div>
              <span className={`${styles.label} ${isActive ? styles.active : styles.inactive}`}>
                {item.label}
              </span>
            </button>
          </div>
        );
      })}
    </nav>
  );
};